export default __webpack_public_path__ + "static/media/AnnualOffer-arrow.5c78011d.svg";